import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

interface Tour {
  id: string;
  name: string;
  embedUrl: string;
}

const tours: Tour[] = [
  {
    id: 'grand-duo-64a',
    name: 'Grand Duo - 64A',
    embedUrl: 'https://kuula.co/share/collection/7Hbbx?logo=0&info=0&fs=1&vr=1&zoom=1&sd=1&initload=0&thumbs=-1&alpha=0.60&inst=0'
  }
];

const TourViewPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  
  const tour = tours.find(t => t.id === slug);

  if (!tour) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black text-white">
        <div className="text-center">
          <h1 className="text-2xl mb-4">Tour não encontrado</h1>
          <button
            onClick={() => navigate('/tours')}
            className="px-4 py-2 bg-white text-black rounded hover:bg-gray-200"
          >
            Voltar para Tours
          </button>
        </div>
      </div>
    );
  }

  return (
    <iframe
      src={tour.embedUrl}
      title={tour.name}
      className="fixed inset-0 w-screen h-screen border-0"
      allowFullScreen
      allow="xr-spatial-tracking; gyroscope; accelerometer"
      scrolling="no"
    />
  );
};

export default TourViewPage;
